/* eslint-disable react/no-deprecated */

/**
 * We are disabling the react/no-deprecated,
 * because the bellowing code is used in integration,
 * and we are not ready yet to upgrade to ES 6 syntax.
 */

let React = require('react');
let PT = require('prop-types');
let up = require('react-addons-update');

const createClass = require('create-react-class');

export const Login = createClass({
    displayName: "Login",

    propTypes: {
        redirectURLAfterLogin: PT.string
    },

    getInitialState(){
        return {
            userid: tsapp.user.pi,
            profile:null,
            errorOnAction: "", // LOUCHE : This state doesn't seem to be used
            showRegisterProfile: false
        };
    },
   
    componentWillMount(){
        this.loadProfile();
        if(this.props.onContentChange !== undefined) this.props.onContentChange();
    },

     componentWillUnmount() {

        if (this.itemRequest != null) this.itemRequest.abort();
    },

    loadProfile(){
        this.itemRequest = tsapp.mvcapi.postCtl("profile/profileinfo")
            .success(function(data){
                let profile = up(data.profile, { [ "PasswordValidation" ]: { $set: data.profile.Password }} );
                this.setState({profile});
            }.bind(this))
            // eslint-disable-next-line lodash/prefer-noop
            .notSuccess(function(){
                // TODO: What do we hate to do here?
            }.bind(this));
    },

    handleOnChangeEmail(email){
        this.setState({email});
    },

    handleOnChangePassword(password){
        this.setState({password});
    },

    handleOnConnect(){
        // Google Analytics virtual page
        //if(typeof dataLayer !== "undefined") dataLayer.push({ event: 'form-submit', "form-type": 'formulaire-connexion-compte' });

        // Refresh the cart status widget if applies.
        this.itemRequest = tsapp.mvcapi.postCtl("login/currentuserinfo")
            .success(function(data){
                this.setState({userid:data.user.pi});
                
                if (this.props.onConnectSuccess) {
                    this.props.onConnectSuccess(this.state.userid);
                    return;
                }

                this.loadProfile();
                
                let forcedURL = this.props.redirectURLAfterLogin;
                if(forcedURL != undefined && forcedURL.length > 0)
                    parent.location.href = forcedURL;
                else
                    tsapp.goToHome(this.props.integ);
            }.bind(this))
            .notSuccess(function(data){
                this.setState({errorOnAction:(data.message == "CART_IS_EMPTY") ? data.message: ""});
            }.bind(this));
    },

    handleOnRegisterProfile(){
        parent.location.href = "/register";
    },

    
    render() {
        return (
            // tsapp is defined globally
            // eslint-disable-next-line react/jsx-no-undef
            <tsapp.ctl.login.LoginPanel 
                email={this.state.email} 
                password={this.state.password} 
                onRegisterProfile={this.handleOnRegisterProfile} 
                onChangeEmail={this.handleOnChangeEmail} 
                onChangePassword={this.handleOnChangePassword} 
                onConnectSuccess={this.handleOnConnect}
                integ={this.props.integ}
            />
        );
    }
});
